// modules
import React, { useState, useContext, useEffect } from "react";
import "../styles/RangeSelector.scss";
import { Button } from "@mui/material";
import { GlobalContext } from "../context/GlobalContext";

const ranges = ["1M", "3M", "6M", "YTD", "Max"];

const RangeSelector = () => {
  const { state, dispatch } = useContext(GlobalContext);
  const { allReleases, latestRelease, rangeReleases, selectedTimeRange } = state;
  const [currRange, setCurrRange] = useState("");

  useEffect(() => {
    if (allReleases.length > 0) {
      handleClick("Max");
    }
  }, [allReleases]);

  const handleClick = (range) => {
    dispatch({ type: 'SELECTED_TIME_RANGE', payload: range });
    updateRangeReleases(range)
    setCurrRange(range);
  };

  const updateRangeReleases = (range) => {
    if (!allReleases || allReleases.length === 0) return;
  
    const now = new Date();
    let fromDate;
  
    switch (range) {
      case '1M':
        fromDate = new Date();
        fromDate.setMonth(now.getMonth() - 1);
        break;
      case '3M':
        fromDate = new Date();
        fromDate.setMonth(now.getMonth() - 3);
        break;
      case '6M':
        fromDate = new Date();
        fromDate.setMonth(now.getMonth() - 6);
        break;
      case 'YTD':
        fromDate = new Date(now.getFullYear(), 0, 1); // Jan 1 of this year
        break;
      case 'Max':
        fromDate = new Date(0); // Epoch (return all)
        break;
      default:
        fromDate = new Date(0); // Fallback: all data
    }
  
    const filtered = allReleases.filter((release) => {
      const releaseDate = new Date(release.CreationTimestamp); // assuming 'date' is in ISO format
      return releaseDate >= fromDate && releaseDate <= now;
    });

    dispatch({ type: 'RANGE_RELEASES', payload: filtered });
  };

  return (
    <div className="rs-main-container">
      <span className="rs-title">Select a time range</span>
      <div className="rs-div" style={{ display: "flex", alignItems: "center" }}>
        {ranges.map((range, index) => (
          <React.Fragment key={range}>
            <Button
              onClick={() => handleClick(range)}
              disableRipple
              style={{
                backgroundColor: "transparent",
                border: "none",
                minWidth: "auto",
                padding: "6px 12px",
                color: currRange === range ? "var(--purple)" : "white",
                textDecoration: currRange === range ? "underline" : "none",
                fontWeight: "bold",
                fontSize: "1em",
                textTransform: "none",
              }}
            >
              {range}
            </Button>
            {index < ranges.length - 1 && (
              <span
                style={{
                  color: "gray",
                  marginTop: "-4px",
                  marginRight: "10px",
                  marginLeft: "10px",
                  fontSize: "1.2em",
                }}
              >
                |
              </span>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default RangeSelector;
